import { useTranslation } from 'react-i18next';

import styled, { keyframes, }  from 'styled-components';
import Navbar from './navbar';

const InOut = keyframes` from { opacity: 0; } to { opacity: 1; } `
const BreakNews = styled.button` width: 100%; outline: 0; margin: 0; padding: 1px 1px; color: #222; 
                                 font-weight: 600; border-radius: 20px; background-color: transparent; 
                                 border: 2px solid red; transition: all 240ms ease-in-out; cursor: pointer; `;
                                 
const BreakNewsTxt = styled.button` animation: ${InOut} 5s linear infinite; `;

const Header = ({ nbOfProducts }) => 
{ const { t } = useTranslation();
  //const { i18n } = useTranslation();
  return (
    <header className='header'>
       <div className="App">
          <Navbar />
          <video width="1280" height="150" autoplay="true"> 
          <source src="https://www.azed.fr/videos/Idx/Banner/banner.mp4" type="video/mp4"/></video>
       </div>
       <BreakNews>
          <BreakNewsTxt>{t('Late-breaking-news')}</BreakNewsTxt>
       </BreakNews>
       <div className='container'>
          <h3>{t('HeaderButton.ItemsList')}&nbsp;:&nbsp;({nbOfProducts})</h3>
          {/*<h1>----{i18n.language}---</h1>*/}
       </div>
    </header>
  )
}

export default Header;